import React from 'react';

import styles from './ideaViewsBreakdownStyles';

import LoadingSpinner from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';
import IdeaViewsBreakdownSection from './IdeaViewsBreakdownSection/ideaViewsBreakdownSection';

import GlobeIcon from 'buyside/svgs/globe.svg';
import BriefcaseIcon from 'SVGs/briefcase';
import CoinStackIcon from 'buyside/svgs/coin_stack.svg';

const BREAKDOWN_CATEGORIES = [
  { attr: 'viewerCityName', title: 'Geography', icon: GlobeIcon },
  { attr: 'viewerFundType', title: 'Firm Type', icon: BriefcaseIcon },
  { attr: 'viewerAumRange', title: 'AUM', icon: CoinStackIcon }
];

const IdeaViewsBreakdown = ({ loading = false, views, isAllIdeas = false }) => {
  return (
    <div className={styles.viewsBreakdownContainer}>
      <div className={styles.viewsBreakdownCallout}>
        SumZero only displays user activity information about the last 10 users viewing your{' '}
        {isAllIdeas ? 'ideas' : 'idea'}. The full breakdown of all member data for views of{' '}
        {isAllIdeas ? 'your ideas' : 'this idea'} is represented in the charts below.
      </div>
      <h4 className={styles.viewsBreakdownHeader}>
        Views Breakdown for{' '}
        {isAllIdeas ? 'All of Your Ideas' : `your idea on ${views[0].ideaAssetSymbol}`}
      </h4>
      {loading && <LoadingSpinner type="secondary" size="large" />}
      {!loading && (
        <div className={styles.viewsBreakdown}>
          {BREAKDOWN_CATEGORIES.map((cat, idx) => (
            <IdeaViewsBreakdownSection
              key={idx}
              views={views}
              attr={cat.attr}
              title={cat.title}
              icon={cat.icon}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default IdeaViewsBreakdown;
